import { useEffect, useState } from 'react'

import SocialIcon from 'components/misc/SocialIcon'
import styles from './styles/SharingWidget.css'
import * as analytics from 'lib/analytics'
import classNames from 'classnames'

const SharingWidget = ({ type, title, url = '', copy = '', services = ['twitter', 'facebook', 'linkedin'], className, iconClassName }) => {
  const [pageURL, setPageURL] = useState(url)

  const handleClick = (place) => {
    analytics.event({
      category: 'User',
      action: `Shared ${type} to ${place}`
    })
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && !url) {
      setPageURL(window.location.href)
    }
  }, [])
  const text = copy || `scite ${type} - ${title}`

  return (
    <div className={classNames(className, styles.container)}>
      {services.includes('twitter') && (
        <SocialIcon onClick={() => handleClick('twitter')} className={iconClassName || styles.icon} type='twitter' href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(pageURL)}`} />
      )}
      {services.includes('facebook') && (
        <SocialIcon onClick={() => handleClick('facebook')} className={iconClassName || styles.icon} type='facebook' href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageURL)}`} />
      )}
      {services.includes('linkedin') && (
        <SocialIcon onClick={() => handleClick('linkedin')} className={iconClassName || styles.icon} type='linkedin' href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageURL)}`} />
      )}
    </div>
  )
}

export default SharingWidget
